import { useState } from 'react';
import { FaBell } from 'react-icons/fa';
import { useNotifications } from '@/hooks/useNotifications';
import NotificationDropdown from './NotificationDropdown';

export default function NotificationBell() {
    const { notifications, unreadCount, markAsRead, markAllAsRead } = useNotifications();
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => setIsOpen(!isOpen);

    return (
        <div className="relative">
            <button
                onClick={toggleDropdown}
                className="relative p-2 rounded-full hover:bg-gray-700 transition-colors focus:outline-none text-gray-300 hover:text-white"
                aria-label="Notifications"
            >
                <FaBell className="w-5 h-5" />
                {unreadCount > 0 && (
                    <span className="absolute top-0 right-0 inline-flex items-center justify-center px-1.5 py-0.5 text-xs font-bold leading-none text-white transform translate-x-1/4 -translate-y-1/4 bg-red-600 rounded-full">
                        {unreadCount > 99 ? '99+' : unreadCount}
                    </span>
                )}
            </button>

            <NotificationDropdown
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                notifications={notifications}
                onRead={markAsRead}
                onReadAll={markAllAsRead}
            />
        </div>
    );
}
